/**
 * Unify stitched Kling native speech to one ElevenLabs voice (speech-to-speech — keeps lip-sync timing).
 * @param {Function} hitAxios
 * @param {{
 *   video_url: string;
 *   voice_id?: string;
 *   seed_audio_url?: string;
 *   job_id?: number;
 * }} payload
 */
export async function unifyStitchedVoice(hitAxios, payload) {
  const res = await hitAxios({
    path: "/api/video-studio/unify-stitched-voice",
    post: true,
    obj: payload,
    showLoading: false,
    showSnackbar: false,
    timeout: 600000,
  });

  if (res?.logout) {
    throw new Error("Session expired. Please sign in again.");
  }
  if (!res?.data?.success) {
    const msg =
      res?.data?.msg ||
      res?.error ||
      (res?.response?.data?.msg ? String(res.response.data.msg) : "") ||
      "Could not unify voice on stitched video.";
    throw new Error(msg);
  }
  return res.data.data || {};
}
